import { SafeLink } from "@/components/ui/SafeLink";
import { Button } from "@/components/ui/button";
import { SlideFromLeft, SlideFromRight } from "@/components/ui/animations";

export default function ResidentialCommercialTiles() {
    return (
        <div className="w-full bg-gradient-to-b from-gray-50 to-gray-100 relative overflow-hidden">
            {/* Background decorative elements */}
            <div className="absolute inset-0 pointer-events-none">
                <div className="absolute top-0 left-1/4 w-32 h-32 bg-red-500/3 rounded-full blur-3xl"></div>
                <div className="absolute bottom-1/3 right-1/4 w-48 h-48 bg-gray-900/2 rounded-full blur-3xl"></div>
            </div>
            
            <div className="flex flex-col md:flex-row lg:flex-row w-full max-w-6xl mx-auto px-4 lg:px-8 gap-0 md:gap-4 lg:gap-12">
                {/* Residential Projects - left on large screens */}
                <div className="w-full lg:w-1/2 flex flex-col">
                    <SlideFromLeft Component={
                        <div id="residential-projects" className="flex flex-col items-center gap-8 pt-14 pb-12 relative z-10">                            
                            <div className="relative group w-full max-w-2xl transform transition-all duration-700 hover:-translate-y-3 hover:scale-105">                            
                                <img
                                    loading="eager"
                                    className="w-full h-40 sm:h-56 md:h-64 object-cover rounded-2xl shadow-lg group-hover:shadow-2xl transition-all duration-700"
                                    src={`${process.env.REACT_APP_BLOB_URL}/www/img/sector/building-construction-residential.jpg`}
                                    alt="Newly built residential home – Harvey Norman Commercial Project"
                                />
                                {/* Dark overlay for hover effect */}
                                <div className="absolute inset-0 bg-black/20 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                                {/* Animated shine effect */}
                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 rounded-2xl"></div>
                            </div>
                            <div className="flex flex-col gap-6 px-4 text-center max-w-2xl">                                
                                <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
                                    <span className="hero-text-gradient-red">Residential </span> Projects
                                </h2>
                                <p className="text-lg text-gray-600 leading-relaxed">
                                    Turn every home or multi-unit residential development into a showcase. We supply quality appliances, designer furniture, and all the finishing touches that make your builds and renovations memorable—and market-ready.
                                </p>
                            </div>
                        </div>
                    } />
                </div>

                {/* Commercial Projects - right on large screens */}
                <div className="w-full lg:w-1/2 flex flex-col">
                    <SlideFromRight Component={
                        <div id="commercial-projects" className="flex flex-col items-center gap-8 pt-14 pb-12 relative z-10">                            
                            <div className="relative group w-full max-w-2xl transform transition-all duration-700 hover:-translate-y-3 hover:scale-105">                            
                                <img
                                    loading="eager"
                                    className="w-full h-40 sm:h-56 md:h-64 object-cover rounded-2xl shadow-lg group-hover:shadow-2xl transition-all duration-700"
                                    src={`${process.env.REACT_APP_BLOB_URL}/www/img/sector/building-construction-commercial.jpg`}
                                    alt="Modern commercial building with glass and brick façade"
                                />
                                {/* Dark overlay for hover effect */}
                                <div className="absolute inset-0 bg-black/20 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                                {/* Animated shine effect */}
                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 rounded-2xl"></div>
                            </div>
                            <div className="flex flex-col gap-6 px-4 text-center max-w-2xl">                                
                                <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
                                    <span className="hero-text-gradient-red">Commercial </span> Projects
                                </h2>
                                <p className="text-lg text-gray-600 leading-relaxed">
                                    From first impression to final inspection, we help you elevate every commercial fit-out. Offices, retail, hospitality—we deliver ergonomic furniture, high-performance appliances, and professional AV systems built to handle the real world.
                                </p>
                            </div>
                        </div>
                    } />
                </div>
            </div>
        </div>
    )
}